import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'basic-diolog-refresh',
  templateUrl: './basic-dialog-refresh.component.html',
  styleUrls: ['./basic-dialog.component.css']
})
export class BasicDialogComponentRefresh  implements AfterViewInit {
  @Input()
  title: string = "";
  @Input()
  content: string = "";
  constructor(public activeModal: NgbActiveModal) {
  }
  onOkClick(): void {
    console.log("@@@ onOKClick");
    window.location.reload(); // This will refresh the page

  }
  ngAfterViewInit(): void {
  }
}
